(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["protein-menu-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('an-protein-menu')) {
    customElements.define('an-protein-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const tabs = [...this.querySelectorAll('[data-protein-tab]')];
        const views = [...this.querySelectorAll('[data-protein-view]')];
        const tablist = this.querySelector('[data-protein-tabs]');
        const mobile = this.classList.contains('protein-menu--mobile');
        tablist.setAttribute('role', 'tablist');
        tablist.setAttribute('aria-orientation', mobile ? 'horizontal' : 'vertical');
        const activate = (tab, focus = false) => {
          tabs.forEach(item => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          views.forEach(view => { view.hidden = view.dataset.proteinView !== tab.dataset.proteinTab; });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          const view = views.find(item => item.dataset.proteinView === tab.dataset.proteinTab);
          tab.id = view.id + '-tab';
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', view.id);
          view.setAttribute('role', 'tabpanel');
          view.setAttribute('aria-labelledby', tab.id);
          view.tabIndex = 0;
          tab.addEventListener('click', event => { event.preventDefault(); activate(tab); });
          tab.addEventListener('keydown', event => {
            const next = mobile ? 'ArrowRight' : 'ArrowDown';
            const previous = mobile ? 'ArrowLeft' : 'ArrowUp';
            let target;
            if (event.key === next) target = tabs[(index + 1) % tabs.length];
            if (event.key === previous) target = tabs[(index + tabs.length - 1) % tabs.length];
            if (event.key === 'Home') target = tabs[0];
            if (event.key === 'End') target = tabs[tabs.length - 1];
            if (event.key === ' ' || event.key === 'Enter') target = tab;
            if (target) { event.preventDefault(); activate(target, true); }
          });
        });
        activate(tabs[0]);
        this.dataset.ready = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
